module.exports = __webpack_public_path__ + "img/letter.b598f7a9.svg";